/**
 * Sprint 23.8 — workspace overview hook (the `/home` daily briefing).
 *
 * Wraps `get_workspace_overview` — one round-trip for the identity strip meta,
 * scorecard, workforce health, connections, needs-attention, and recent
 * activity. Polled every 60s (Q15 — aggregates change slowly; the live status
 * sections — workforce pulse, needs attention — poll faster on their own).
 * `refetchInterval` pauses while the tab is hidden (no
 * `refetchIntervalInBackground`); `refetchOnWindowFocus` refreshes on return.
 */

import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { useAuth } from "../../lib/hooks/use-auth";
import type { WorkspaceOverview } from "../../lib/types";

const POLL_MS = 60_000;

export function useWorkspaceOverview() {
  const { currentWorkspaceId } = useAuth();
  return useQuery<WorkspaceOverview>({
    queryKey: ["workspace-overview", currentWorkspaceId],
    queryFn: () => mcpClient.getWorkspaceOverview(),
    enabled: !!currentWorkspaceId,
    staleTime: 30_000,
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
  });
}
